const DEMO = resolve => require(['@/view/demo.vue'], resolve)
const MQ = resolve => require(['@/view/active-mq.vue'], resolve)
const WS = resolve => require(['@/components/common/ws/websocket.vue'], resolve)
const EDITOR = resolve => require(['@/view/editor.vue'], resolve)

const demoRouter = [
    {
        path: '/demo',
        name: 'DEMO',
        component: DEMO,
        children: [
            {path: '/mq', name: 'MQ', component: MQ},
            {path: '/ws', name: 'WS', component: WS},
        ]
    },
    {
        path: '/test/editor',
        name: 'EDITOR',
        component: EDITOR,
    }

]
export default demoRouter;



// WEBPACK FOOTER //
// ./src/router/demo.js